<!-- Setting 'multiple' through attribute is not allowed so need to define seperately-->
<input #multiFileInput type="file" (change)="fileInputChange($event)" class="hidden" multiple />
<input #fileInput type="file" (change)="fileInputChange($event)" class="hidden" />
